<template>
  <div class="reader-tab" :class="{active: item.value === activeLable}" @click="onClick">
    {{text}}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default () {
        return {
          value: ''
        }
      }
    },
    activeLable: {
      type: String
    }
  },
  data () {
    return {

    }
  },
  methods: {
    onClick () {
      this.$emit('onClick', this.item);
    }
  }
}
</script>

<style lang="scss" scoped>
.reader-tab {
  display: flex;
  align-items: center;
  padding-left: 10px;
  cursor: pointer;
  white-space: nowrap;
  color: rgba(#474261, 0.5);
  &:hover {
    color: #474261;
  }
  &.active {
    font-weight: bold;
    color: #474261;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dialogs/smartVoice/readerTab.vue